const D = 100;
export {
  D as LOADING_DISMISS_DELAY
};
//# sourceMappingURL=dataGrid.js.map
